import { Label } from '@/components/ui/label'
import { Skeleton } from '@/components/ui/skeleton'

export const LocationFallback = () => (
  <div className="flex flex-col gap-2 w-full">
    <Label>Location</Label>
    <Skeleton className="h-9 w-full" />
  </div>
)
